import React from "react";
import { formatTL } from "@/lib/api";
import { STh } from "@/components/SortTh";

export function SnapCard({ label, value, tone }) {
  const toneCls = tone === "emerald" ? "bg-emerald-50 border-emerald-200 text-emerald-800" :
                  tone === "indigo" ? "bg-indigo-50 border-indigo-200 text-indigo-800" :
                  "bg-slate-50 border-slate-200 text-slate-800";
  return (
    <div className={`rounded-lg p-3 border ${toneCls}`}>
      <div className="text-[10px] font-semibold uppercase tracking-wider opacity-80">{label}</div>
      <div className="font-mono-tab font-bold text-base mt-1">{value}</div>
    </div>
  );
}

export function Th({ children, align, center, right, k }) {
  const cls = right || align === "right" ? "text-right" : (center ? "text-center" : "text-left");
  const full = `px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 ${cls}`;
  if (k) return <STh k={k} className={full}>{children}</STh>;
  return (
    <th className={full}>
      {children}
    </th>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 block mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export function ExitRow({ label, value }) {
  return (
    <tr className="border-b border-slate-100 last:border-b-0">
      <td className="px-3 py-2 text-slate-700">{label}</td>
      <td className="px-3 py-2 text-right font-mono-tab font-semibold text-slate-900">{formatTL(value || 0)}</td>
    </tr>
  );
}
